module.exports = __webpack_public_path__ + "static/prairie-8be2b2dc8308c2f0c94ca63f62a2d042.jpg";